import commonServices from "src/services/common"

class TypesGroupHandler {
    #list = [];

    constructor() {
        if (typeof window === 'undefined') return
        try {
            this.#list = JSON.parse(localStorage.getItem("typesGroup"))
        } catch (e) { }
    }
    #getList() {
        if (this.#list) {
            return Promise.resolve(this.#list)
        } else {
            return commonServices?.getTypeList().then((response) => {
                const list = response?.data?.value
                localStorage.setItem("typesGroup", JSON.stringify(list))
                this.#list = list
                return list
            })
        }
    }
    getGroupId(key) {
        return this.#getList().then((list) => {
            const group = list?.find(item => item?.name === key)
            return group?.id
        })
    }
}
const typesGroupHandler = new TypesGroupHandler()
export default typesGroupHandler